import { MaskIcon } from '#src/atoms/ui/MaskIcon/index.tsx';
import type { Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  /**
   * Branding image URL, resolved by the caller from its closest query
   * (`assetUrl(slot: …)`) or a `useCurrentSet*` hook. Renders nothing when
   * absent (base set, unpopulated legacy set, query still loading).
   */
  url?: Nullable<string>;
  /** Height as a design unit — for the square set icon. */
  size?: Unit;
  /** Explicit height in px — for the set logo. */
  height?: number;
  /** Explicit width in px — for the set logo. */
  width?: number;
  color?: Color;
  title?: string;
  className?: string;
};

/**
 * Recolorable set-branding image (icon or logo) rendered through `MaskIcon`.
 * Presentational: the caller supplies the resolved `url`.
 */
export const SetBrandingImage = ({
  url,
  size,
  height,
  width,
  color,
  title,
  className,
}: Props) => {
  if (!url) {
    return null;
  }

  return (
    <MaskIcon
      url={url}
      size={size}
      height={height}
      width={width}
      color={color}
      title={title}
      className={className}
    />
  );
};
